import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: SectionState = {
  all: [],
};

const getters: GetterTree<SectionState, RootState> = {
  all(state: SectionState): Section[] {
    return state.all;
  },
};

const mutations: MutationTree<SectionState> = {
  RESET(state: SectionState) {
    state.all = [];
  },
  ADD_MODEL(state: SectionState, payload: Section) {
    state.all.push(payload);
  },
  SET_MODELS(state: SectionState, payload: Section[]) {
    state.all = payload;
  },
};

const resource: string = 'sections';

const actions: ActionTree<SectionState, RootState> = {
  patch({ commit, rootState }, payload: { productId: number; sections: ProductSections; workspaceId: number }) {
    return rootState.api
      .patch(`products/${payload.productId}/${resource}`, { sections: payload.sections }, { withCredentials: true, headers: { common: { 'x-workspace-id': payload?.workspaceId } } })
      .then((response: { data: Section }) => {
        commit('SET_MODELS', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
  index({ commit, rootState }, payload: { productId: number; workspaceId: number }) {
    return rootState.api
      .get(`products/${payload.productId}/${resource}`, { withCredentials: true, headers: { common: { 'x-workspace-id': payload?.workspaceId } } })
      .then((response: { data: Section }) => {
        commit('SET_MODELS', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
